import { render, staticRenderFns } from "./inventoryTable.vue?vue&type=template&id=b2561360&scoped=true"
import script from "./inventoryTable.vue?vue&type=script&lang=js"
export * from "./inventoryTable.vue?vue&type=script&lang=js"
import style0 from "./inventoryTable.vue?vue&type=style&index=0&id=b2561360&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2561360",
  null
  
)

export default component.exports